import HDPOpenHouses from "./components/HDPOpenHouses";
import hdpStore from "./redux/hdpStore";
import withInitializationHDP from "./redux/utilities/withInitializationHDP";

const enhanceHDP = withInitializationHDP(hdpStore);

const HDPOpenHousesApp = enhanceHDP(HDPOpenHouses);

export default HDPOpenHousesApp;
